let serverTimeAtSyncMs = 0;
let perfAtSyncMs = 0;
let synced = false;

function perfNowMs(): number {
  const perf = (globalThis as { performance?: { now: () => number } })
    .performance;
  return perf?.now() ?? Date.now();
}

/**
 * Records the server time anchored to `performance.now()`.
 * Called once when the server time API response arrives.
 */
export function setSyncedTime(serverMs: number): void {
  serverTimeAtSyncMs = serverMs;
  perfAtSyncMs = perfNowMs();
  synced = true;
}

export function isClockSynced(): boolean {
  return synced;
}

/**
 * Returns current server time in milliseconds.
 * Uses a monotonic clock (`performance.now()`) so changing the system
 * clock after sync has zero effect.
 * Throws if called before the server time API has responded.
 */
export function serverNow(): number {
  if (!synced) throw new Error("Server clock not synced.");
  return serverTimeAtSyncMs + (perfNowMs() - perfAtSyncMs);
}
